import CitySEOHead from "@/components/feature/CitySEOHead";
import HawaiiHeroSection from "./components/HeroSection";
import HawaiiCitiesDirectory from "./components/CitiesDirectory";
import CommunitiesWeServe from "./components/CommunitiesWeServe";
import HawaiiStateResources from "./components/StateResources";
import HawaiiFAQSection, { faqs as rawFaqs } from "./components/FAQSection";
import HawaiiFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

const faqs = rawFaqs.map((f: { question: string; answer: string }) => ({ q: f.question, a: f.answer }));

const servicesSchema = [
  { name: "Emergency Passport", description: "Urgent passport processing for Hawaii travelers with immediate departure needs, as fast as 24 hours without leaving the islands." },
  { name: "Passport Renewal", description: "Fast passport renewal for Hawaii residents with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance for Hawaii residents with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for Hawaii residents with lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16 in Hawaii, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service for Hawaii residents after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent Hawaii travelers and damaged passport replacement." },
];

export default function HawaiiPage() {
  return (
    <>
      <CitySEOHead
        city="Hawaii"
        state="Hawaii"
        stateAbbr="HI"
        route="/states/hawaii"
        title="Hawaii Passport Services — Expedited & Emergency | Fast Passport Center"
        description="Expedited passport services across Hawaii — Honolulu, Hilo, Kailua, Kahului, Kauai, Maui, Big Island, and all communities. Emergency processing as fast as 24 hours. A+ BBB rated courier service serving every Hawaiian island and town."
        geoPlacename="Hawaii, United States"
        geoPosition="19.8968;-155.5828"
        faqs={faqs}
        servicesSchema={servicesSchema}
      />
      <div className="font-sans">
        <HawaiiHeroSection />
        <HawaiiCitiesDirectory />
        <CommunitiesWeServe />
        <HawaiiStateResources />
        <HawaiiFAQSection />
        <SEOCrossLinks state="HI" showCities={false} />
        <HawaiiFinalCTA />
      </div>
    </>
  );
}